import React, { useLayoutEffect, useState } from 'react';

import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import publicImage from '../../../utils/publicImage';

import styles from './index.module.scss';

interface IProps {
  image: string;
  alt?: string;
  description?: any;
}

const Image = (props: IProps) => {
  const {
    image,
    alt,
    description
  } = props;

  return (
    <Zoom ZoomContent={CustomZoomContent}>
      <img
        onError={(event) => {
          const target = event.target;
          (target as HTMLImageElement).src = publicImage('no-image.png');
        }}
        className={styles.image}
        aria-label="Hello"
        src={image}
        alt={alt} />
    </Zoom>
  )
}


const CustomZoomContent = (props: any) => {

  const {
    buttonUnzoom, // default unzoom button
    modalState,   // current state of the zoom modal: UNLOADED, LOADING, LOADED, UNLOADING
    img,          // your image, prepped for zooming
  } = props;
  const [isLoaded, setIsLoaded] = useState(false)

  useLayoutEffect(() => {
    if (modalState === 'LOADED') {
      setIsLoaded(true)
    } else if (modalState === 'UNLOADING') {
      setIsLoaded(false)
    }
  }, [modalState])

  const classCaption = isLoaded
    ? 'zoom-caption zoom-caption--loaded'
    : 'zoom-caption'

  return (
    <>
      {buttonUnzoom}        
      <figure>
        {img}
        <figcaption className={classCaption}>
          { img.props.alt}
        </figcaption>
      </figure>
    </>
  )
}

export default Image;
